import { ConfirmModal } from '../../components/ConfirmModal';
import './OrganizationTrial.css';

interface ClearTrialModalProps {
  isOpen: boolean;
  organizationName: string;
  loading: boolean;
  error: string | null;
  onConfirm: () => void;
  onClose: () => void;
}

/**
 * Confirms taking the trial off an organization.
 *
 * Says that the dates are not kept, because this is also the only route back from a conversion
 * recorded by mistake and an admin taking that route is about to lose the window they had.
 */
export const ClearTrialModal = ({
  isOpen,
  organizationName,
  loading,
  error,
  onConfirm,
  onClose,
}: ClearTrialModalProps) => (
  <ConfirmModal
    isOpen={isOpen}
    title="Clear trial"
    message={`Clear the trial for "${organizationName}"? The dates are removed and the trial notices stop. This also clears a recorded conversion, so it is the way back from one marked by mistake. The dates are not kept, so putting this organization back on a trial means entering them again.`}
    confirmText={loading ? 'Clearing...' : 'Clear trial'}
    busy={loading}
    onConfirm={onConfirm}
    onClose={onClose}
  >
    {error && (
      <div
        className="org-trial-form__error"
        role="alert"
        data-testid="org-trial-clear-error"
      >
        {error}
      </div>
    )}
  </ConfirmModal>
);
